module.exports = __webpack_public_path__ + "static/img/6.0cf6f5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxopen/6.png
// module id = zrrt
// module chunks = 1